module.exports = __webpack_public_path__ + "static/media/menu-icon.7a42a6ef.svg";